import React, {useEffect, useRef} from "react";
import LeafGroup from "../components/smsc/LeafGroup";
import LeftLeaf from "../components/smsc/LeftLeaf";
import gsap from "gsap";
import { useInView } from "react-intersection-observer";

function Vines(props) {
    return (
      <svg
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="-58.14 0.48 1620.69 303"
        {...props}
      >
        <path
          d="M477.445 303.484c22.677 0 45.396-.427 68.159-1.282 165.641-6.238 334.164-35.095 500.896-85.758 283.88-86.272 466.66-207.64 468.46-208.858l-4.75-7.102c-1.8 1.21-183.72 121.983-466.47 207.862-260.806 79.212-663.231 144.088-1099.263 3.32l-2.614 8.119c172.238 55.624 352.106 83.699 535.582 83.699z"
          fill="#B8E2CB"
        />
        <path
          d="M1054.68 230.008a1816.57 1816.57 0 01-67.025 12.429c-163.521 27.147-334.406 32.716-507.912 16.562C184.318 231.485-19.11 149.29-21.113 148.457l3.22-7.909c2.01.822 204.474 82.609 498.709 109.965 271.401 25.232 678.654 7.983 1077.544-217.468l4.19 7.428c-157.56 89.076-328.13 152.694-507.87 189.535z"
          fill="#BBF0D2"
        />
      </svg>
    )
  }
  

const MissionVines = () => {

    const leftItem = useRef(null)
    const rightItem = useRef(null)

    const { ref, inView } = useInView({
      /* Optional options */
      threshold: 0.2,
      delay: 200,
      triggerOnce: true,
    });
  
    useEffect(() => {
      if (inView) {
        gsap.to(leftItem.current, {
          duration: 1,
          x: 0,
          opacity: 1,
          rotate: 0,
          skewX: 0,
          ease: "power1.inOut",
        });
        gsap.to(rightItem.current, {
          duration: 1,
          x: 0,
          rotate: 0,
          skewX: 0,
          opacity: 1,
          ease: "power1.inOut",
        });



      }
    }, [inView]);

  
    

    return(
        <div className="relative" ref={ref}>
          <div ref={leftItem} className="absolute -rotate-45 opacity-0 top-0 left-[-30px] lg:left-[-240px] w-[155px] lg:w-[30vw] max-w-[500px] origin-bottom-left z-[5] translate-x-[-10vw] skew-x-12">
          <LeftLeaf />

          </div>
            <div className="scale-x-110">
            <Vines/>

            </div>

            <div ref={rightItem} className="absolute rotate-45 opacity-0 top-[-5px] lg:top-[-50px] right-[-30px] lg:right-[-240px] w-[155px] lg:w-[30vw] max-w-[500px] origin-bottom-right z-[5] translate-x-[10vw] -skew-x-12">
            <LeafGroup/>

            </div>


        </div>
    )
}

export default MissionVines